// src/views/EditOrderFees.jsx
import React, { useEffect, useState } from 'react';
import { FaPlus, FaSave, FaTrash, FaSync } from 'react-icons/fa';
import './Invoices.css';

const API = import.meta.env.VITE_API_URL;

export default function EditOrderFees() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/templates/orderfees`);
      const j = await r.json();
      setRows(Array.isArray(j) ? j : []);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const addRow = () => setRows(prev => [{ id: null, feename: '', description: '', amt: 0, auto: 0, xpallets: 0, _new: true }, ...prev]);

  const saveRow = async (row) => {
    setSavingId(row.id || 'new');
    try {
      const body = { feename: row.feename, description: row.description, amt: Number(row.amt || 0), auto: Number(row.auto)?1:0, xpallets: Number(row.xpallets)?1:0 };
      if (!row.id) {
        const r = await fetch(`${API}/api/templates/orderfees`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        const j = await r.json();
        if (!r.ok || j?.error) throw new Error(j?.error || 'Create failed');
        setRows(prev => prev.map(x => x === row ? { ...j, _new: undefined } : x));
      } else {
        const r = await fetch(`${API}/api/templates/orderfees/${row.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        const j = await r.json().catch(()=>({}));
        if (!r.ok || j?.error) throw new Error(j?.error || 'Save failed');
        setRows(prev => prev.map(x => x.id === row.id ? { ...row } : x));
      }
    } catch (e) { alert(e.message || 'Save failed'); }
    finally { setSavingId(null); }
  };

  const deleteRow = async (row) => {
    if (!row.id) { setRows(prev => prev.filter(x => x !== row)); return; }
    if (!window.confirm('Delete this template fee?')) return;
    try {
      const r = await fetch(`${API}/api/templates/orderfees/${row.id}`, { method: 'DELETE' });
      const j = await r.json().catch(()=>({}));
      if (!r.ok || j?.error) throw new Error(j?.error || 'Delete failed');
      setRows(prev => prev.filter(x => x.id !== row.id));
    } catch (e) { alert(e.message || 'Delete failed'); }
  };

  return (
    <div className="invoices-wrapper" style={{ gap: 12, width: '75%' }}>
      <div className="invoice-filters" style={{ justifyContent:'space-between' }}>
        <h2 style={{ margin: 0 }}>Edit Order Fees</h2>
        <div style={{ display:'flex', gap:8 }}>
          <button className="btn" onClick={addRow}><FaPlus style={{ marginRight: 6 }}/> Add</button>
          <button className="btn" onClick={load}><FaSync style={{ marginRight: 6 }}/> Refresh</button>
        </div>
      </div>

      {loading ? <div className="loading">Loading…</div> : (
        <div className="invoice-table-wrapper">
          <table className="invoice-table shrink-cols">
            <thead>
              <tr>
                <th className="actions-col">Actions</th>
                <th className="fit-col">Fee Name</th>
                <th className="fit-col">Amount</th>
                <th className="fit-col">Auto</th>
                <th className="fit-col">xPallets</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((r, idx) => (
                <tr key={r.id || `n-${idx}`}>
                  <td className="actions-cell">
                    <button className="mini-btn" onClick={() => saveRow(r)} disabled={savingId!=null} title="Save"><FaSave size={16}/></button>
                    <button className="mini-btn danger" onClick={() => deleteRow(r)} title="Delete"><FaTrash size={16}/></button>
                  </td>
                  <td className="fit-col">
                    <input value={r.feename || ''} onChange={e => setRows(prev => prev.map(x => x === r ? { ...x, feename: e.target.value } : x))} />
                  </td>
                  <td className="fit-col">
                    <input type="number" step="0.01" value={r.amt} onChange={e => setRows(prev => prev.map(x => x === r ? { ...x, amt: e.target.value } : x))} style={{ width: '8ch' }} />
                  </td>
                  <td className="fit-col">
                    <input type="checkbox" checked={!!Number(r.auto)} onChange={e => setRows(prev => prev.map(x => x === r ? { ...x, auto: e.target.checked ? 1 : 0 } : x))} />
                  </td>
                  <td className="fit-col">
                    <input type="checkbox" checked={!!Number(r.xpallets)} onChange={e => setRows(prev => prev.map(x => x === r ? { ...x, xpallets: e.target.checked ? 1 : 0 } : x))} />
                  </td>
                  <td>
                    <input value={r.description || ''} onChange={e => setRows(prev => prev.map(x => x === r ? { ...x, description: e.target.value } : x))} />
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={6}>No order fee templates</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
